var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.OzPopover,{attrs:{"anchor":_vm.popoverAnchor,"config":{
    placement: 'top',
    middleware: [_setup.offset(20), _setup.flip()],
  },"role":"dialog","aria-label":_vm.__('Add post menu')},on:{"scrim-esc":function($event){return _vm.$emit('close-menu')},"scrim-click":function($event){return _vm.$emit('close-menu')}}},[_c(_setup.OzBox,{class:[
      'w-[351px]',
      'p-2',
      'backdrop-blur-6',
      'overflow-y-auto overflow-x-hidden',
      'scrollbar-thin dark:scrollbar-thin-dark',
      'flex flex-col gap-3',
      'rounded-3xl',
    ],attrs:{"color":_setup.OzBoxColors.PrimaryLight,"role":"menu","aria-label":_vm.__('Content selection')}},_vm._l((_vm.buttons),function(button,index){return _c('div',{key:index},[_c(_setup.OzBaseButton,{class:[
          'w-full',
          'bg-grey-100 dark:bg-grey-800',
          'group',
          'flex items-center gap-2',
          'py-2 ps-4 pe-11 rounded-2xl',
          'text-dark-text-200 dark:text-light-text-200 font-semibold',
          // Hovered
          'hhover:bg-grey-200 dark:hhover:bg-grey-600',
          // Active
          'hactive:bg-grape-500 dark:hactive:bg-canary-500 hactive:text-light-text-100 dark:hactive:text-dark-text-100',
          // Focused
          'focus-visible:rounded-2xl',
          'focus-visible:outline-none',
          'focus-visible:ring-[2.5px]',
          'focus-visible:ring-grape-500 dark:focus-visible:ring-canary-500',
        ],on:{"click":function($event){return _setup.handleClick(button.action)},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;$event.preventDefault();return _setup.handleClick(button.action)}}},[_c(_setup.OzIcon,{attrs:{"size":20,"name":button.icon}}),_vm._v(" "),_c('div',{staticClass:"flex-col flex-1 min-w-0 justify-center ps-0.5"},[_c('p',{staticClass:"text-heading-4 truncate"},[_vm._v("\n            "+_vm._s(button.text)+"\n          ")])])],1)],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }